import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import FormField from "./FormField";
import TextInput from "./TextInput";

const DateTimeField = forwardRef(({
  error,
  helpText,
  id,
  label,
  optional = false,
  required = false,
  type = "datetime-local",
  ...inputProps
}, ref) => (
  <FormField error={error} helpText={helpText} id={id} label={label} optional={optional} required={required}>
    {(fieldProps) => <TextInput {...inputProps} {...fieldProps} ref={ref} type={type} />}
  </FormField>
));

DateTimeField.displayName = "DateTimeField";
DateTimeField.propTypes = {
  error: PropTypes.string,
  helpText: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  optional: PropTypes.bool,
  required: PropTypes.bool,
  type: PropTypes.oneOf(["date", "datetime-local", "time"]),
};

export default DateTimeField;
